import { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Translation } from "react-i18next";
import { Subtitle, Caption } from "src/atoms/typography";
import { useControls } from "src/utils/createControls";
import { DeviceMenu } from "./DeviceMenu";
import { DeviceIcon } from "src/modules/device/components/DeviceSpec";

const DeviceContainer = ({ children, isHovered, ...rest }) => (
  <Flex
    px="24px"
    height="60px"
    justifyContent="space-between"
    alignItems="center"
    bg={isHovered ? "iconBackground" : "surfaceElevated1"}
    transition="background 300ms"
    {...rest}
  >
    {children}
  </Flex>
);

function DeviceContent({ jid, name }) {
  return (
    <Flex alignItems="center">
      <Box mr="16px">
        <DeviceIcon deviceJid={jid} />
      </Box>
      <Subtitle color="highEmphasis">{name}</Subtitle>
    </Flex>
  );
}

export function Device({ onRemove, onRename, ...rest }) {
  const [isHovered, setHover] = useState(false);
  const menu = useControls(false);

  return (
    <DeviceContainer
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      isHovered={isHovered}
    >
      <DeviceContent {...rest} />
      {isHovered && (
        <DeviceMenu
          isOpen={menu.isOpen}
          onOpen={menu.open}
          onClose={menu.close}
          onRemove={onRemove}
          onRename={onRename}
        />
      )}
    </DeviceContainer>
  );
}

export function ThisDevice({ device, onRename }) {
  const [isHovered, setHover] = useState(false);
  const menu = useControls(false);

  return (
    <Translation>
      {(t) => (
        <DeviceContainer
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          isHovered={isHovered}
        >
          <DeviceContent {...device} />
          <Flex alignItems="center">
            <Caption
              transition="all 0.3s"
              mr={isHovered ? "16px" : "0px"}
              color="mediumEmphasis"
            >
              {t("pairedDevices.thisDevice")}
            </Caption>
            {isHovered && (
              <DeviceMenu
                isOpen={menu.isOpen}
                onOpen={menu.open}
                onClose={menu.close}
                onRename={onRename}
              />
            )}
          </Flex>
        </DeviceContainer>
      )}
    </Translation>
  );
}
